<template>
  <v-card>
    <v-card-text>
      <div>{{ note }}</div>
      <div v-if="!!signature">
        <v-img
          :src="signature"
          max-width="100"
        />
      </div>
      <div>{{ display_name }} <v-chip>{{ $ucfirst($userRole(user_role)) }}</v-chip>, {{ timeFormatted }}</div>
    </v-card-text>
  </v-card>
</template>

<script>
import moment from 'moment';

export default {
  name: 'SignatureNote',
  props: ['display_name', 'user_role', 'signature', 'note', 'created'],

  computed: {
    timeFormatted() {
      const date = moment(this.created).format('dddd, DD.MM.YYYY');
      const time = moment(this.created).format('H:mm');

      return `${date} ob ${time}`;
    },
  }
}
</script>
